import { render } from "./OurTopCourses.vue?vue&type=template&id=d5660b1a&ts=true"
import script from "./OurTopCourses.vue?vue&type=script&lang=ts"
export * from "./OurTopCourses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__